// Constellations: one card per constellation the player wrote, its figure
// large against a textured patch of the night's sky (ConstellationArt), with
// its name and its number of stars below.
import type { Constellation, PlayLevel } from '@wits/core';
import { ConstellationArt, figureOf, type Figure } from '../../sky/ConstellationArt';
import { WEEKDAY_SKIES, weekdayFromDate, type WeekdaySky } from '../../sky/weekdaySkies';

interface Props {
  level: PlayLevel;
  constellations: readonly Constellation[];
  date: string;
}

export function ConstellationCards({ level, constellations, date }: Props) {
  if (constellations.length === 0) return <p>No constellations were written.</p>;
  const sky = WEEKDAY_SKIES[weekdayFromDate(date)];
  return (
    <ul className="constellation-cards">
      {constellations.map((c) => {
        const figure = figureOf(level, c);
        return <ConstellationCard key={c.word} figure={figure} stars={figure.nodes.filter((n) => n.type === 'star').length} sky={sky} />;
      })}
    </ul>
  );
}

/** One card: the figure on the night's sky, its name and its number of stars. Also the home menu's. */
export function ConstellationCard({ figure, stars, sky }: { figure: Figure; stars: number; sky: WeekdaySky }) {
  return (
    <li className="constellation-card">
      <ConstellationArt figure={figure} width={296} height={148} padX={30} padY={24} maxScale={0.42} top={sky.top} mid={sky.mid} className="constellation-art" />
      <div className="constellation-meta">
        <span className="constellation-name">{figure.word}</span>
        <span className="constellation-count label-mono quiet">
          {stars} {stars === 1 ? 'star' : 'stars'}
        </span>
      </div>
    </li>
  );
}
